import { render, staticRenderFns } from "./LpuMistakeBtn.vue?vue&type=template&id=11de8d02&"
import script from "./LpuMistakeBtn.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuMistakeBtn.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11de8d02')) {
      api.createRecord('11de8d02', component.options)
    } else {
      api.reload('11de8d02', component.options)
    }
    module.hot.accept("./LpuMistakeBtn.vue?vue&type=template&id=11de8d02&", function () {
      api.rerender('11de8d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuMistakeBtn.vue"
export default component.exports